export default __webpack_public_path__ + "static/media/demo.e4533f9f.png";